import React, { useRef } from 'react'
import AppModal from 'components/organisms/CustomModal'
import Button from 'components/atoms/Button'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import CopyText from 'components/atoms/CopyText'
import SeerbitLogo from '../../../assets/images/SeerbitLogoTyped.png';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useReactToPrint } from 'react-to-print'

const ViewTransaction = (props) => {
    const useNewRefEle = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();

    const handlePrint = useReactToPrint({
        content: () => useNewRefEle.current,
    });

    const handleDownloadPdf = () => {
        const input = useNewRefEle.current;
        if (input) {
            html2canvas(input)
                .then((canvas) => {
                    const imgData = canvas.toDataURL('image/png');
                    const pdf = new jsPDF();
                    const imgProps = pdf.getImageProperties(imgData);
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                    pdf.save('download.pdf');
                })
                .catch((error) => {
                    console.error('Could not generate PDF', error);
                });
        }
    };

    return (
        <AppModal
            handleClose={props.toggleModal}
            modalStyle="desktop:w-1/4 mobile:w-3/4 bg-white min-h-screen z-30 !top-0 right-0 animate-slide_left"
            contentStyle="flex flex-col justify-between gap-5 overflow-y-scroll h-[92vh]"
        >


            <div ref={useNewRefEle} className='flex flex-col gap-12 h-full p-8 pb-4'>
                <div className='flex flex-col gap-2 '>
                    <div className='bottom-0 flex justify-start text-white mb-8'>
                        <img src={SeerbitLogo} alt='SeerbitLogo' className='w-[75px] h-auto' />
                    </div>
                    <div className='flex flex-col text-left'>
                        <span className='font-normal text-2xl mobile:text-lg text-black mb-5'>Transaction Overview</span>
                        <span className='text-[14px] mobile:text-xs leading-7 text-SecondaryAccent'>View the details of the transaction.</span>
                    </div>
                </div>

                <div className='flex flex-col gap-8 w-full'>
                    <div className='mb-5 flex flex-col gap-5'>
                        <div>
                            <span className='text-base mobile:text-sm leading-7 text-SecondaryAccent'>Amount</span>
                            <div className='flex gap-3 items-center'>
                                <span className='font-bold text-[28px] mobile:text-xl leading-7 text-DarkBg3'>{props.data.currency + " " + (Intl.NumberFormat().format(props.data.amount))}</span>
                                <span className={`${props.data.transactionStatus === 'COMPLETED' ? 'bg-[#04A7781a] text-Success2' : props.data.transactionStatus === 'FAILED' ? 'bg-DangerAccent5 text-Danger4' : props.data.transactionStatus === 'NOT_STARTED' ? 'bg-Yellow_Accent text-Yellow' : 'bg-SecondaryAccent11 text-Accent_blue6'} px-[10px] py-[5px] rounded-md`}>
                                    {props.data.transactionStatus === 'COMPLETED'
                                        ? 'Success'
                                        : props.data.transactionStatus === 'FAILED'
                                            ? 'Failed'
                                            : props.data.transactionStatus === 'NOT_STARTED'
                                                ? 'Pending'
                                                : 'Expired'
                                    }
                                </span>
                            </div>
                        </div>

                        <div className='flex flex-col gap-3'>
                            <span className='text-[15px] font-normal leading-7 text-SecondaryAccent'>{moment(props.data.date).format("MMM DD, YYYY - LTS")}</span>
                            <CopyText
                                text={props.data.paymentReference}
                                displayedText={props.data.paymentReference.length > 20 ? props.data.paymentReference.slice(0, 20) + "..." : props.data.paymentReference}
                                textStyle="text-opacity-70 text-xs inline-block item-center bg-GrayCustom3 px-3 py-1 rounded-md"
                                mssgStyle='-right-3 -top-[18px] hidden'
                                imgStyle="w-4 h-4"
                            />
                        </div>
                    </div>

                    <div className='flex flex-col'>
                        <span className='border-b border-SecondaryAccent2 font-semibold text-[18px] mobile:text-sm leading-6 text-DarkBg pb-4 mb-5'>
                            Payment Breakdown
                        </span>
                        <div className='flex flex-col gap-5'>
                            <span className='w-full flex justify-between'>
                                <p className='font-normal text-xs leading-3 text-Black2'>Transaction  Amount</p>
                                <p className='font-semibold text-sm leading-[16.8px] text-DarkBg8'>{props.data.currency + " " + (Intl.NumberFormat().format(props.data.amount))}</p>
                            </span>
                            <span className='w-full flex justify-between'>
                                <p className='font-normal text-xs leading-3 text-Black2 mb-3'>Trannsaction fee</p>
                                <p className='font-semibold text-sm leading-[16.8px] text-DarkBg8'>{props.data.currency + " " + (Intl.NumberFormat().format(props.data.fee))}</p>
                            </span>
                        </div>
                    </div>

                    <div className='flex flex-col'>
                        <span className='border-b border-SecondaryAccent2 font-semibold text-[18px] mobile:text-sm leading-6 text-DarkBg pb-4 mb-5'>
                            Other Information
                        </span>
                        <div className='flex flex-col gap-5'>
                            {/* <div className='w-full flex justify-between items-center gap-5'>
                                <span className='font-normal text-xs leading-3 text-Black2'>Receiver Name</span>
                                <span className='font-semibold text-sm leading-[16.8px] text-DarkBg8'>{props.data.customerName}</span>
                            </div> */}
                            <div className='w-full flex justify-between items-center gap-5'>
                                <span className='font-normal text-xs leading-3 text-Black2'>Payment Channel</span>
                                <span className='font-semibold text-sm leading-[16.8px] text-DarkBg8'>{props.data.paymentChannel}</span>
                            </div>
                            {/* <div className='w-full flex justify-between items-center gap-5'>
                                <span className='font-normal text-xs leading-3 text-Black2'>Receiver Account Number</span>
                                <CopyText 
                                    text={props.data.receiverAccountNumber}
                                    textStyle="text-opacity-70 text-xs inline-block item-center bg-GrayCustom3 px-3 py-1 rounded-md"  
                                    mssgStyle='-right-3 -top-[18px] hidden' 
                                    imgStyle="w-4 h-4"
                                    style="flex-row-reverse"
                                />
                            </div> */}
                            <div className='w-full flex justify-between items-center gap-5'>
                                <span className='font-normal text-xs leading-3 text-Black2'>Transation Status</span>
                                <span className={`${props.data.transactionStatus === 'COMPLETED' ? 'bg-Green_Accent8 text-Success2' : props.data.transactionStatus === 'FAILED' ? 'bg-DangerAccent5 text-Danger4' : props.data.transactionStatus === 'NOT_STARTED' ? 'bg-Yellow_Accent text-Yellow' : 'bg-SecondaryAccent11 text-Accent_blue6'} px-[10px] py-[5px] rounded-md`}>
                                    {props.data.transactionStatus === 'COMPLETED'
                                        ? 'Success'
                                        : props.data.transactionStatus === 'FAILED'
                                            ? 'Failed'
                                            : props.data.transactionStatus === 'NOT_STARTED'
                                                ? 'Pending'
                                                : 'Expired'
                                    }
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='w-full flex flex-col gap-5  p-8 pt-4'>
                <Button
                    btnType='button'
                    btnText="Print PDF"
                    btnStyle='bg-SecondaryAccent3 text-[15px] font-normal leading-7 text-black w-full py-3 cursor-pointer'
                    onClick={handlePrint}
                />
                {/* <Button
                        btnType='button'
                        btnText="See detailed overview"
                        btnStyle='bg-SecondaryAccent3 text-[15px] font-normal leading-7 text-black w-full py-3 cursor-pointer'
                        onClick={() => {
                            navigate(`/dashboard/transactions/transaction_overview/${props.data.paymentReference}`, { state: { transactionData: props.data } })
                            props.toggleModal()
                        }}
                    /> */}
                <Button
                    btnType='button'
                    btnText="Close"
                    btnStyle='bg-DarkBg3 text-[15px] font-normal leading-7 text-white w-full py-3 cursor-pointer'
                    onClick={props.toggleModal}
                />
            </div>
        </AppModal>
    )
}

export default ViewTransaction
